export const WALL_TILE = {
  char: '#',
  fg: '#999',
  bg: '#666',
  fogFg: '#444',
  fogBg: '#111',
  isWalkable: false,
  isVisible: false,
  seen: false,
};
export const FLOOR_TILE = {
  char: '.',
  fg: '#888',
  bg: '#000',
  fogFg: '#333',
  fogBg: '#000',
  isWalkable: true,
  isVisible: false,
  seen: false,
};
export const STAIR_DOWN = {
  char: '<',
  fg: '#fff',
  bg: '#000',
  fogFg: '#ccc',
  fogBg: '#000',
  isWalkable: true,
  isVisible: false,
  seen: false,
};
export const STAIR_UP = {
  char: '>',
  fg: '#fff',
  bg: '#000',
  fogFg: '#ccc',
  fogBg: '#000',
  isWalkable: true,
  isVisible: false,
  seen: false,
};
export const ENTER_TILE = {
  char: '&',
  fg: '#0f0',
  bg: '#000',
  fogFg: '#0c0',
  fogBg: '#000',
  isWalkable: true,
  isVisible: false,
  seen: false,
};
